var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "greetings" }, [
    _c("div", { staticClass: "header__top" }, [
      _vm.showExit
        ? _c("button", {
            staticClass: "action-icon close",
            attrs: { "aria-label": _vm.$gettext("Cerrar chat"), tabindex: "0" },
            on: {
              click: _vm.closeChat,
              keyup: [
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.closeChat.apply(null, arguments)
                },
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "space", 32, $event.key, [
                      " ",
                      "Spacebar",
                    ])
                  )
                    return null
                  return _vm.closeChat.apply(null, arguments)
                },
              ],
            },
          })
        : _vm._e(),
      _c("div", { staticClass: "header__greetings" }, [
        _vm.isUserLogged
          ? _c("p", { attrs: { tabindex: "0" } }, [
              _vm._v("Hej "),
              _c("br"),
              _c("span", [_vm._v(_vm._s(_vm.name) + "!")]),
            ])
          : _c("p", {
              directives: [{ name: "translate", rawName: "v-translate" }],
              staticClass: "bold__greeting hej__greeting",
              style:
                this.$store.state.greetingText == "Hej!"
                  ? ""
                  : "font-size: 16px",
              attrs: { tabindex: "0" },
              domProps: { innerHTML: _vm._s(this.$store.state.greetingText) },
            }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }